module.exports = __webpack_public_path__ + "media/images/team__4acesgc-5204065c94fb77ed0a7d062bb1157afc.png";